import React, {useEffect, useMemo, useRef, useState} from "react";
import {LoginContainer, LoginDropdown, LoginLoadingContainer} from "./Login.style";
import {Helpers} from "@tpd-web-common-libs/nodejs-library";
import {TpdLoading, TpdModal} from "@tpd-web-react-libs/nodejs-library/dist/src/components";
import {LoginForm} from "./LoginForm";
import {isRedirectToCompletamentoRegistrazione, logout, sendAnalytics} from "./LoginHelper";
import {
    GetData1Response,
    ServiceLevelResponseWithTimestamp,
    UpdatePreventiviPolizzeParam
} from "@tpd-web-react-libs/nodejs-library/dist/src/interfaces";
import {
    CommunicationService,
    CrmService,
    EncryptionService,
    InfoUtenteResponse,
    LocalStorageLayer,
    LoginService,
    NotificheService,
    PreventiviPolizzeService,
    SelfRegistrationService,
    SessionStorage,
    UserService
} from "@tpd-web-react-libs/nodejs-library/dist/src/providers";
import {useOnClickOutside} from "@tpd-web-react-libs/nodejs-library/dist/src/hooks";
import {CommonFunctions, Constants} from "@tpd-web-react-libs/nodejs-library/dist/src/common";
import {ChangePasswordForm} from "./ChangePasswordForm";
import {InfoUtente} from "./InfoUtente";
import {NotificheUtente} from "./NotificheUtente";
import { BrandNameHelper } from "@tpd-web-common-libs/nodejs-library/dist/src/helpers";

type TLowerHeaderDesktopProps = {
    __host__: any;
    id: string;
    isEditMode: boolean;
    isLogoutOnly: boolean
    config: any;
};

const URL = Constants.url[1];
const TODAY = new Date();

const Login = (props: TLowerHeaderDesktopProps) => {
    const {
        __host__,
        isEditMode,
        isLogoutOnly,
        id: containerID,
        config,
    } = props;

    config.config = config.config ? config.config : {
        mod: 'DESKTOP',
    }

    const localStorageLayerService = new LocalStorageLayer();
    const notificheService = new NotificheService();


    const isServerSide = useMemo<boolean>(Helpers.EnvironmentHelper.isServerSide, [])
    const isClientSide = useMemo<boolean>(Helpers.EnvironmentHelper.isClientSide, [])

    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isCheckingLoggedInUser, setIsCheckingLoggedInUser] = useState<boolean>(true);
    const [isLogged, setIsLogged] = useState<boolean>(false); //default: false
    const [helloName, setHelloName] = useState<string>(''); //default: ''
    const [privacyLevel, setPrivacyLevel] = useState<string>('');
    const [isPF, setPF] = useState<boolean>(false); //default: false
    const [unreadNotifications, setUnreadNotifications] = useState<number>(0); //default: 0
    const [authFailed, setAuthFailed] = useState<boolean>(false);

    const [changePassword, setChangePassword] = useState<boolean>(false);
    const [changePasswordUsername, setChangePasswordUsername] = useState<string>("");
    const [changePasswordPassword, setChangePasswordPassword] = useState<string>("");

    const [isDisabled, setDisabled] = useState<boolean>(false);
    const [isCaptchaDisabled, setCaptchaDisabled] = useState<boolean>(false);
    // const [isAuthFailed, setAuthFailed] = useState<boolean>(false);
    const isUtenteUnipolMove = useRef<boolean>(false);
    const isSuperUserPage = useRef<boolean>(false);
    const isWaitPG = useRef<boolean>(false);
    const isUsernameSet = useRef<boolean>(false);
    const isLoadUnbluScriptEnabled = useRef<boolean>(false); //Se impostato su true effettua il caricamento dello script di unblu da next
    const singlePolicy = useRef<any>();
    const commercialPrivacy = useRef<any>();
    const ignoreUserPrivacyPage = useRef<any>();

    const [isPrivacyCREnabled, setIsPrivacyCREnabled] = useState(true);

    const [isLoginDropdownOpen, setLoginDropdownOpen] = useState<boolean>(false);
    const clickOutsideRef = useRef(null);
    const handleClickOutside = () => {
        if (isLoginDropdownOpen) setLoginDropdownOpen(false);
    }

    let isLoggedNoReact = false;    //Flag di login staccato dal flusso REACT
    let ivass = false;              //Flag di gestione delle sessioni IVASS
    let notificationsSub: any;      //Subscription

    useOnClickOutside(clickOutsideRef, handleClickOutside);

    useEffect(() => {

        if (Helpers.EnvironmentHelper.isClientSide()) {
            const href = window.location.href;
            if (href.includes(`qa.${BrandNameHelper.urlName()}`) ||
                href.includes(`sit.${BrandNameHelper.urlName()}`) ||
                href.includes(`dev.${BrandNameHelper.urlName()}`) ||
              href.includes("localhost")) {
                setIsPrivacyCREnabled(true);
            }
        }

        //TODO: Controllare come mai prima la condizione era senza la negazione, chiedere ad Emanuele
        if (!isClientSide) return;
        onMounted();

        return () => {
            onUnmounted();
        };
    }, []);

    const onMounted = async () => {
        // constructor
        caricaScriptUnblu();

        // on init
        if (!Helpers.PageHelper.isHCLAuthoringPage()) {
            // await init();
            init();
        }

        // after content init
        if (!Helpers.PageHelper.isHCLAuthoringPage()) {
            const logout = CommonFunctions.getParameterByName("logout");
            if (logout === "true") logout();
        }
    }

    const onUnmounted = () => {
        // on destroy
        notificationsSub?.unsubscribe();
    }

    const caricaScriptUnblu = () => {
        if (isClientSide && isLoadUnbluScriptEnabled.current) {
            const script = document.createElement("script") as HTMLScriptElement;
            script.type = "text/javascript";
            script.src = "/NextAssets/scripts/unblu.js";
            window.document.body.appendChild(script);
        }
    }

    const init = async () => {
        const isLoggedTemp = await CommonFunctions.isUserLogged();
        isLoggedNoReact = isLoggedTemp;
        setIsLogged(isLoggedTemp);
        setIsCheckingLoggedInUser(false);

        // if (isLoggedNoReact) {
        //     new UserService().getAnagrafica().catch((e) => {
        //         console.error("Errore getAnagrafica", e)
        //     });
        // }

        isUtenteUnipolMove.current = await CommonFunctions.isUtenteUnipolMove();
        notificationsSub = new CommunicationService<number>(Constants.NOTIFICATION_COUNT_UPDATE).getObservable().subscribe((count) => {
            setUnreadNotifications(count);
        });

        let values;
        try {
            values = await Promise.all([
                Helpers.SessionHelper.getData(Constants.lsMapObject._data5),
                Helpers.SessionHelper.getData(Constants.lsMapObject._data5_1),
                Helpers.SessionHelper.getData("IVASS"),
            ]);
        } catch (error) {
            values = [];
        }

        // after init
        const [data5Storage, data51Storage, localIvass] = values;

        ivass = localIvass;
        if (data5Storage) {
            const jsonObject = JSON.parse(data5Storage);
            if (jsonObject.value0 === "0") {
                isSuperUserPage.current = jsonObject.value0 === "0";
                if ((jsonObject.value1 != null && jsonObject.value1 !== "") || data51Storage) {
                    isUsernameSet.current = true;
                }
            }
        }

        if (
            typeof window === "object" &&
            window.location.href.indexOf("home-superuser") > -1
        ) {
            isSuperUserPage.current = true;
        } else {
            isSuperUserPage.current = false;
        }

        if (isLoggedNoReact && !isUtenteUnipolMove.current && !isSuperUserPage.current) {
            handleGetData1();
        }
    }

    const handleLogoutFromErrorModal = (): void => {
        setModalOpen(false);
        logout();
    }

    const setLoadingStatus = (status: boolean): void => {
        setLoading(status);
        if (typeof window === "object" && typeof document === "object") {
            if (status === true) {
                const body = document.querySelector("body");
                body.style.overflow = "hidden";
            } else {
                const body = document.querySelector("body");
                body.style.overflow = "auto";
            }
        }
    }

    const handle = (resolve, urlToGo) => {
        // TODO inserire la gestione alla pagina di completamento login.

        //Se il servizio di privacy restituisce valore diverso da 06, l'utente non ha mai cliccato su "Non Ora" e non è WAIT_PG,
        //salvo nel local storage il valore dell'url a cui l'utente dev'essere rediretto, e poi setto come urlToGo la pagina di Privacy.
        //Nella pagina di privacy questo valore sarà letto e l'utente verrà rimandato a quella pagina.
        if (
            commercialPrivacy.current && commercialPrivacy.current !== Constants.privacyLevels.PRIVACY_2_3_ACCEPTED &&
            !ignoreUserPrivacyPage.current && !isWaitPG.current
        ) {
            localStorageLayerService.getData3(11, [urlToGo]).then(() => {
                urlToGo = URL.privacypage;
                resolve(urlToGo);
            })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            //Altrimenti se commercialPrivacy non è valorizzato mando in homepage con parametro cpUnd (commercial privacy undefined)
            if (!commercialPrivacy.current) {
                urlToGo = "".concat(URL.homepage, "?cpUnd=true");
                resolve(urlToGo);
            }
            //Se è valorizzato con != 06, verifico se è WAIT_PG, in questo caso mando in HP, altrimenti mando alla pagina in urlToGo
            else {
                if (isWaitPG.current) {
                    urlToGo = URL.homepage;
                    resolve(urlToGo);
                } else {
                    resolve(urlToGo);
                }
            }
        }
    }

    /**
     * Creata per omnibus, verifica se il livello di privacy è 06, se lo è ritorna la pagina in cui deve atterrare secondo le logiche precedenti,
     * altrimenti salva questa pagina nel ls Data3 e ritorna la pagina di privacy in cui l'utente deve atterrare post login
     */
    const urlManager = (urlToGo: string): Promise<string> => {
        return new Promise((resolve) => {
            //E' andato storto qualcosa in fase di login, il servizio non restituisce una url di atterraggio valida, mando in homepage con parametro cpUnd (commercial privacy undefined)
            if (urlToGo.indexOf("/login") > -1 || urlToGo === "") {
                urlToGo = "".concat(URL.homepage, "?cpUnd=true");
            }

            //Se il servizio di login restituisce come url aggiornamentoProfilo ma è già stato validato, mando in homepage
            if (urlToGo.indexOf(URL.aggiornamentoProfilo) > -1) {
                SessionStorage.getData("alreadyValidate")
                    .then((val) => {
                        urlToGo = URL.homepage;
                        handle(resolve, urlToGo);
                    })
                    .catch((e) => {
                        handle(resolve, urlToGo);
                    });
            } else {
                handle(resolve, urlToGo);
            }
        }).then((finalLoginUrl: string) => {
            if (finalLoginUrl) {
                return Helpers.UrlHelper.completeUrlWithCurrentOrigin(
                    `/myportal/tpdweb/accesso?redirectTo=${finalLoginUrl.replace(
                        "?",
                        "&"
                    )}`
                );
            } else {
                return finalLoginUrl;
            }
        });
    }

    const redirectTo = (urlToGo: string): void => {
        urlManager(urlToGo)
            .then((responseUrl) => {
                setLoadingStatus(false);
                Helpers.RouterHelper.goTo(responseUrl);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const roadAssistanceValidation = (urlToGo) => {
        setLoadingStatus(true);
        const correctMonth =
            (TODAY.getMonth() + 1).toString().length < 2
                ? "0" + (TODAY.getMonth() + 1).toString()
                : (TODAY.getMonth() + 1).toString();
        const correctDay =
            TODAY.getDate().toString().length < 2
                ? "0" + TODAY.getDate().toString()
                : TODAY.getDate().toString();
        const todayDate =
            TODAY.getFullYear().toString() +
            "-" +
            correctMonth +
            "-" +
            correctDay;
        const companyCode = CommonFunctions.calculateCompany(
            singlePolicy.current.company
        );
        new CrmService().getRoadsideAssistance(
            singlePolicy.current.numberPlate,
            companyCode,
            singlePolicy.current.policy,
            singlePolicy.current.branch,
            singlePolicy.current.agency,
            todayDate
        ).then((response) => {
            if (
                response &&
                response.operationResult &&
                // tslint:disable-next-line: triple-equals
                response.operationResult.type == "0" &&
                response.roadsideAssistenceGuarantee.assistenceFlag === "true"
            ) {
                localStorageLayerService.deleteData7().then((response) => {
                    // tslint:disable-next-line: triple-equals
                    if (response.message == "ok") {
                        const data = {
                            plate: singlePolicy.current.numberPlate,
                            policy: singlePolicy.current.policy,
                            company: companyCode,
                        };
                        localStorageLayerService.setData7(9, null, data).then((response) => {
                            redirectTo(urlToGo.onePlate);
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                });
            } else {
                redirectTo(urlToGo.noPlates);
            }
        }).catch(() => {
            redirectTo(urlToGo.noPlates);
        });
    }

    const checkPlates = (responseGetData1: GetData1Response, sectionToGo: string) => {
        let finalUrl;

        const redirect = [
            {
                noPlates: URL.denunceinviate,
                onePlate: URL.preaperturasinistro,
                morePlates: URL.denuncianuovosinistro,
            },
            {
                noPlates: URL.noTargheAssistenza,
                onePlate: URL.motivazione,
                morePlates: URL.sceltaTarghePas,
            },
        ];

        switch (sectionToGo) {
            case "sinistri":
                finalUrl = redirect[0];
                break;
            case "pas":
                finalUrl = redirect[1];
                break;
        }

        const parameters = [];
        if (
            responseGetData1 &&
            responseGetData1.policies &&
            responseGetData1.policies.length > 0
        ) {
            for (const policy of responseGetData1.policies) {
                // tslint:disable-next-line: triple-equals
                if (policy.division == 1001) {
                    const obj = {
                        plate: policy.numberPlate,
                        policy: policy.policy,
                    };
                    parameters.push(obj);
                    singlePolicy.current = policy;
                }
            }
            // tslint:disable-next-line: triple-equals
            if (parameters.length == 0) {
                // CASO 0 TARGHE
                finallyLogin(finalUrl.noPlates);
            }
            // tslint:disable-next-line: triple-equals
            else if (parameters.length == 1) {
                // CASO 1 TARGA
                if (parameters[0]) {
                    if (sectionToGo === "pas") {
                        roadAssistanceValidation(finalUrl);
                    } else {
                        localStorageLayerService
                            .deleteData3()
                            .then(() => {
                                localStorageLayerService
                                    .getData3(6, [
                                        null, // publicId
                                        null, // stato,
                                        null, // step,
                                        parameters[0].plate, // targa
                                        parameters[0].policy, // policy
                                    ])
                                    .then((response) => {
                                        finallyLogin(finalUrl.onePlate);
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                }
            } else {
                // CASO >1 TARGA
                finallyLogin(finalUrl.morePlates);
            }
        } else {
            finallyLogin(finalUrl.noPlates);
        }
    }

    const redirects = (
        urlToLogin: string,
        responseGetData1?: GetData1Response,
        username?: string
    ) => {
        // INSERIRE USERNAME IN _data6 AL LOGIN IF WAITPG
        // SE ARRIVA USERNAME ALLORA È WAITPG
        if (username) {
            const id = Constants.lsMapObject._data6;
            const str = { username };
            localStorageLayerService.saveData(id, str);
        }
        if (typeof location === "object" && typeof window === "object") {
            if (responseGetData1) {
                // tslint:disable-next-line: triple-equals
                if (location.href.indexOf("preapertura-sinistro") != -1) {
                    checkPlates(responseGetData1, "sinistri");
                    // tslint:disable-next-line: triple-equals
                } else if (
                    location.href.indexOf("soccorso") != -1 ||
                    location.href.indexOf("/assistenza-stradale") != -1
                ) {
                    checkPlates(responseGetData1, "pas");
                } else {
                    urlManager(urlToLogin)
                        .then((responseUrl) => {
                            // this.setLoading(false);
                            setLoadingStatus(false);
                            Helpers.RouterHelper.goTo(responseUrl, {
                                openNewTab: false,
                            });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            } else {
                urlManager(urlToLogin)
                    .then((responseUrl) => {
                        // this.setLoading(false);
                        setLoadingStatus(false);
                        Helpers.RouterHelper.goTo(responseUrl, {
                            openNewTab: false,
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        }
    }

    const findMore = (
        data,
        urlToLogin: string,
        responseGetData1?: GetData1Response,
        serviceLevel?: string
    ) => {
        if (data[1]) {
            data.splice(0, 1);
            upgradeQuote(data, urlToLogin, responseGetData1, serviceLevel);
        } else {
            redirects(urlToLogin, responseGetData1, serviceLevel);
        }
    }

    const managePreventivoLs = (
        data,
        urlToLogin: string,
        dataPrev,
        result: boolean,
        responseGetData1?: GetData1Response,
        serviceLevel?: string
    ) => {
        dataPrev.alreadyDone = false;
        dataPrev.associated = result;
        localStorageLayerService
            .setPreventivo(dataPrev)
            .then((dataPrec) => {
                findMore(data, urlToLogin, responseGetData1, serviceLevel);
            })
            .catch((problem) => {
                findMore(data, urlToLogin, responseGetData1, serviceLevel);
            });
    }

    const upgradeQuote = (
        data,
        urlToLogin: string,
        responseGetData1?: GetData1Response,
        serviceLevel?: string
    ) => {
        const dataPrev = data[0];
        if (!dataPrev.associated) {
            const model: UpdatePreventiviPolizzeParam = {
                idSessione: dataPrev.idSessione,
                codAgenzia: dataPrev.codPoi,
                email: dataPrev.email,
                targa: dataPrev.targa,
                dataNascita: dataPrev.birthdate,
            };

            PreventiviPolizzeService.updatePreventiviPolizze(model).then(
                (responseSer) => {
                    // AGGIUNGERE CODICE DI RISPOSTA PER PREVENTIVO GIA' ASSOCIATO
                    const result = responseSer && responseSer.result && responseSer.result.type != null &&
                        parseInt(responseSer.result.type) == 0;

                    managePreventivoLs(
                        data,
                        urlToLogin,
                        dataPrev,
                        result,
                        responseGetData1,
                        serviceLevel
                    );
                },
                (error) => {
                    managePreventivoLs(
                        data,
                        urlToLogin,
                        dataPrev,
                        false,
                        responseGetData1,
                        serviceLevel
                    );
                }
            );
        } else {
            findMore(data, urlToLogin, responseGetData1, serviceLevel);
        }
    }

    const callGetPreventivo = (
        urlToLogin: string,
        responseGetData1: GetData1Response,
        serviceLevel?: string
    ) => {
        localStorageLayerService.getPreventivo()
            .then((data) => {
                if (data) {
                    upgradeQuote(data, urlToLogin, responseGetData1, serviceLevel);
                } else {
                    redirects(urlToLogin, responseGetData1, serviceLevel);
                }
            })
            .catch(() => {
                redirects(urlToLogin, responseGetData1, serviceLevel);
            });
    }

    const finallyLogin = (
        urlToLogin: string,
        responseGetData1?: GetData1Response,
        username?: string,
        serviceLevel?: string,
        userLoyaltyProgram?,
        userLoyaltyScore?
    ) => {
        if (responseGetData1) {
            sendAnalytics(
                "login area privata",
                "login utente",
                responseGetData1,
                serviceLevel ? serviceLevel : "",
                userLoyaltyProgram ? userLoyaltyProgram : "",
                userLoyaltyScore ? userLoyaltyScore : ""
            );
        }

        // AGGIUNTA SERVIZIO POST LOGIN STATISTICO se non sei SuperUser (se lo sei, viene fatta una redirect prima)
        new CrmService().myPostLogin()
            .then(() => {
                if (responseGetData1) {
                    callGetPreventivo(urlToLogin, responseGetData1, username);
                } else {
                    redirects(urlToLogin, responseGetData1, username);
                }
            })
            .catch(() => {
                if (responseGetData1) {
                    callGetPreventivo(urlToLogin, responseGetData1, username);
                } else {
                    redirects(urlToLogin, responseGetData1, username);
                }
            });
    }

    const checkErrorLogin = async (loginResponse: Response, loginData: { username: string, password: string }) => {

        if (loginResponse && loginResponse.status === 404) {
            finallyLogin("/error-404");
        }

        const loginResponseJson = await loginResponse.json();
        setLoadingStatus(false);

        if (/^403001$/.test(loginResponseJson?.errorCode)) {
            setCaptchaDisabled(true);
            setAuthFailed(true);
        } else if (/^403002$/.test(loginResponseJson?.errorCode)) {
            // switch to change password form
            setChangePasswordUsername(loginData.username);
            setChangePasswordPassword(loginData.password);
            setChangePassword(true);
        } else if (/^403010$/.test(loginResponseJson?.errorCode)) {
            // this.captchaFailed = true;
        } else {
            setAuthFailed(true);
        }

        setDisabled(false);
    }

    // Verifica utente registrato da altro canale
    const checkUtenteUnipolMove = async () => {
        if (
            typeof location === "object" &&
            !(
                typeof location === "object" &&
                location.href.indexOf("home-superuser") > -1
            ) &&
            CommonFunctions.isUserLogged()
        ) {
            await localStorageLayerService.getData14()
                .then(async (res) => {
                    const currentUrl: string = window.location.pathname;
                    if (isRedirectToCompletamentoRegistrazione(res) &&
                        currentUrl !== URL.completamentoRegistrazione
                    ) {
                        isUtenteUnipolMove.current = await Helpers.SessionHelper.setData(
                            "_isUtenteUnipolMove",
                            true
                        );
                        setLoadingStatus(false);
                        Helpers.RouterHelper.goTo(
                            URL.completamentoRegistrazione
                        );
                    }
                })
                .catch((resError) => {
                    console.error("LoginHeader.clienteServiceError: ", resError);
                });
        }
    }

    const handleGetData1 = async () => {
        if (isLoggedNoReact && (!isSuperUserPage.current || isUsernameSet.current) && !isUtenteUnipolMove.current) {
            localStorageLayerService.getData1()
                .then((responseGetData1: GetData1Response) => {
                    if (
                        responseGetData1 != null &&
                        responseGetData1.registry != null &&
                        responseGetData1.registry.name != null &&
                        responseGetData1.registry.type != null
                    ) {
                        if (responseGetData1.registry.type === Constants.typePersona.personaFisica) {
                            setHelloName(responseGetData1.registry.name);
                            // OK CHE SONO PERSONA FISICA, MA COMUNQUE SE L'UTENTE ACCEDE DA AREA IVASS, LE NOTIFICHE COMMERCIALI NON DEVE VEDERLE.
                            if (ivass) setPF(false);
                            else setPF(true);
                        } else if (responseGetData1.registry.type === Constants.typePersona.personaGiuridica) {
                            setHelloName(responseGetData1.registry.companyName);
                        }
                        if (
                            responseGetData1.registry.commercialPrivacy &&
                            typeof location === "object" &&
                            (location.href.indexOf(`coll.${BrandNameHelper.urlName()}.it`) > -1 ||
                                location.href.indexOf(`svil.${BrandNameHelper.urlName()}.it`) > -1 ||
                                location.href.indexOf(`inte.${BrandNameHelper.urlName()}.it`) > -1)
                        ) {
                            setPrivacyLevel(responseGetData1.registry.commercialPrivacy);
                        }
                    } else {
                        if (
                            typeof window === "object" &&
                            window.location.href.indexOf("home-superuser") > -1
                        ) {
                            logout();
                        }
                    }
                    if (isPF) {
                        Helpers.SessionHelper.getData(Constants.uniqueElencoNotifiche)
                            .then((val: any) => {
                                if (val) {
                                    try {
                                        setUnreadNotifications(JSON.parse(val).numeroNotificheNonLette);
                                    } catch (err: any) {
                                        console.log(err);
                                    }
                                } else {
                                    handleUniqueElencoNotificheCatch();
                                }
                            })
                            .catch((e) => {
                                handleUniqueElencoNotificheCatch();
                            });
                    }

                    function handleUniqueElencoNotificheCatch() {
                        notificheService.getElencoNotifiche(
                            false,
                            Constants.NOTIFICHE.TOPICS.NOTIFICHE_COMMERCIALI
                        ).then((response) => {
                            void Helpers.SessionHelper.setData(
                                Constants.uniqueElencoNotifiche,
                                JSON.stringify(response)
                            );
                            this.unreadNotifications = response.numeroNotificheNonLette;
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    const uniqueGetData1 = async (urlToLogin: string, serviceLevel: string) => {
        const sl: ServiceLevelResponseWithTimestamp = {
            ts: new Date().getTime(),
            serviceLevelResponse: {
                level: serviceLevel,
                operationResult: {
                    type: 0,
                    code: "0",
                },
            },
        };

        const enc = EncryptionService.encryptSingleData(JSON.stringify(sl), 'AES', Constants.vendor.comp);
        if (enc) {
            // TODO: controllare se il fatto che non aspettiamo la fine del set data può causare problemi
            Helpers.SessionHelper.setData(Constants.sl, enc.toString());
            await localStorageLayerService.getData1(false, true)
                .then(
                    async (responseGetData1: GetData1Response) => {
                        //Aggiunta tracciamento user_crm_id ID CRM del cliente come da richiesta Analytics SA 189990
                        if (responseGetData1 && responseGetData1.customer && responseGetData1.customer.customerId) {
                            sessionStorage.setItem("user_crm_id", responseGetData1.customer.customerId);
                            Helpers.SessionHelper.setData("user_crm_id", responseGetData1.customer.customerId)
                        }

                        if (responseGetData1 && responseGetData1.registry && responseGetData1.registry.contactInformations) {

                            // Aggiunto per Omnibus, serve per capire in quale pagina far atterrare l'utente
                            responseGetData1.registry.commercialPrivacy
                                ? (commercialPrivacy.current = responseGetData1.registry.commercialPrivacy)
                                : (commercialPrivacy.current = "CM");

                            if (
                                responseGetData1.registry.type &&
                                responseGetData1.registry.type === Constants.typePersona.personaFisica
                            ) {
                                finallyLogin(urlToLogin, responseGetData1, serviceLevel);
                            } else if (
                                responseGetData1.registry.type &&
                                responseGetData1.registry.type === Constants.typePersona.personaGiuridica
                            ) {
                                // SE PERSONA GIURIDICA SALTO LA CHIAMATA AI POPCOIN
                                finallyLogin(urlToLogin, responseGetData1);
                            } else {
                                setModalOpen(true);
                            }
                        } else {
                            setModalOpen(true);
                        }
                    },
                    (error) => {
                        console.log("Error", error);
                        finallyLogin(urlToLogin);
                    }
                )
                .catch((problem) => {
                    console.log("Error", problem);
                    setModalOpen(true);
                });
        } else setModalOpen(true);
    }

    const avanzamentoLivelloServizi = (
        serviceLevel: string,
        loginUrl: string,
        infoUtente: InfoUtenteResponse
    ) => {
        if (
            (serviceLevel === Constants.serviceLevels.LIGHT || serviceLevel === Constants.serviceLevels.SMART) &&
            infoUtente.esisteContattoValidato
        ) {
            SelfRegistrationService.upgradeServiceLevel()
                .then(() => uniqueGetData1(loginUrl, serviceLevel))
                .catch(() => uniqueGetData1(loginUrl, serviceLevel))
        } else {
            uniqueGetData1(loginUrl, serviceLevel);
        }
    }

    const login = async (username: string, password: string, recaptchaToken: string): Promise<any> => {
        setDisabled(true);
        setAuthFailed(false);

        await CommonFunctions.selectiveStorageClear();

        const uriGotoKey = "uri_goto=";
        const ivass = CommonFunctions.getParameterByName("ivass");
        const urlToLogin = "/login";

        setAuthFailed(false);

        LoginService.loginFn(urlToLogin, username, password, recaptchaToken)
            .then(async (loginResponse: Response) => {
                if (loginResponse.status !== 200) {
                    await checkErrorLogin(loginResponse, { username, password });
                    return;
                }
                // setto l'area ivass se la trovo trai parametri in ingresso
                if (ivass != null && ivass !== "") {
                    void Helpers.SessionHelper.setData("IVASS", true);
                }

                setCaptchaDisabled(true);
                await checkUtenteUnipolMove().then(async () => {
                    if (!isUtenteUnipolMove.current) {

                        await handleGetData1(); // TODO: capire se possiamo ometterlo da qui

                        // TODO: da sistemare dopo test
                        const userService = new UserService();
                        userService.getInfoUtente(false, true, true).then(async (respInfoUtente: InfoUtenteResponse) => {
                            const level = respInfoUtente.livelloServizio || null;
                            ignoreUserPrivacyPage.current = respInfoUtente.posticipaPrivacy;

                            let loginUrl = "";
                            if (loginResponse.url.indexOf("/login") > -1) {
                                if (typeof window === "object" && window.location.href.indexOf(uriGotoKey) > -1) {
                                    loginUrl = window.location.href.split(uriGotoKey)[1];
                                    loginUrl = loginUrl.replace("%2F", "/");
                                } else {
                                    loginUrl = URL.homepage;
                                }
                            } else {
                                loginUrl = loginResponse.url;
                            }

                            if (level === Constants.superUserServiceLevel) {
                                await Helpers.SessionHelper.setData('isSuperUserLogged', true);
                                const superuserUrl =
                                    Helpers.UrlHelper.completeUrlWithCurrentOrigin(
                                        `/myportal/tpdweb/accesso?redirectTo=${URL.superuser.replace(
                                            "?",
                                            "&"
                                        )}`
                                    );
                                Helpers.RouterHelper.goTo(superuserUrl);
                            } else if (level === Constants.serviceLevels.WAIT_PG) {
                                isWaitPG.current = true;

                                void Helpers.SessionHelper.setData(
                                    Constants.lsMapObject.afterPinRedirect,
                                    loginUrl === URL.hub ? loginUrl : URL.homepage
                                );
                                // se e' waitpg passo username da salvare sul storage che utilizzeremo per verifica token
                                finallyLogin(loginUrl, null, username);
                            } else {
                                // SE VA TUTTO A BUON FINE, VADO AVANTI
                                const objProspect = {
                                    classification: respInfoUtente.infoUtente.classificazione,
                                    surname: respInfoUtente.infoUtente.cognome,
                                    name: respInfoUtente.infoUtente.nome,
                                    flagPolizzePresenti: respInfoUtente.flagPolizzePresenti,
                                };
                                localStorageLayerService.saveData(
                                    Constants.lsMapObject._data8,
                                    objProspect
                                );

                                notificheService.getElencoNotifiche(
                                    false,
                                    Constants.NOTIFICHE.TOPICS.NOTIFICHE_COMMERCIALI
                                ).then((response) => {
                                    void Helpers.SessionHelper.setData(
                                        Constants.uniqueElencoNotifiche,
                                        JSON.stringify(response)
                                    );
                                    avanzamentoLivelloServizi(level, loginUrl, respInfoUtente);
                                })
                                    .catch(() => {
                                        avanzamentoLivelloServizi(level, loginUrl, respInfoUtente);
                                    })
                            }
                        })
                            .catch(async () => {
                                urlManager(urlToLogin)
                                    .then((responseUrl) => {
                                        if (typeof window === "object") {
                                            Helpers.RouterHelper.goTo(responseUrl, {
                                                openNewTab: false,
                                            });
                                        }
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                                setDisabled(false);
                            });
                    }
                });
            })
            .catch(async (errResponse) => {
                console.log("#### login - CATCH ", errResponse)
                checkErrorLogin(errResponse, { username, password });
                setLoadingStatus(false);
            });
    }


    if (!isClientSide) {
        return <></>;
    }

    return (
        <>  {!isCheckingLoggedInUser ? (
            <LoginContainer ref={clickOutsideRef}
                className={`widget-global-style ${isLogged ? 'container-login-header' : ''}`}>

                {/* NOT LOGGED - START */}
                {/* #### CTA Icon User*/}
                {!isLogoutOnly && (
                    <div
                        className={`inline ${!isLogged ? 'container-ar-button' : ''}`}
                        onClick={() => setLoginDropdownOpen(!isLoginDropdownOpen)}
                    >
                        {!isLogged && (
                            <span
                                className="inline tpd_top_icon_third uppercase"
                                id="openBox"
                                aria-label="Area Riservata"
                            >
                                Area Riservata<i className="tpd_reserved_area_icon icon-Area-riservata" />
                            </span>
                        )}
                    </div>
                )}

                {/* #### Box Dropdown Login*/}
                {isLoginDropdownOpen && (
                    <LoginDropdown
                        className="login-home"
                    >
                        <div className="login-dropdown_content">
                            <div className="us-row">
                                {!isPrivacyCREnabled &&
                                    <div
                                      className="login-dropdown_title col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-20 col-lg-offset-2">
                                        {!changePassword ? `Entro nell'area riservata ${BrandNameHelper.brandName()}` : "Password scaduta, inserisci una nuova password"}
                                    </div>
                                }
                                {isPrivacyCREnabled &&
                                    <>
                                        {!changePassword ? (
                                          <div
                                              className={"login-dropdown_privacy-text col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-20 col-lg-offset-2"}>
                                                Entrando nell'area riservata, confermo di aver preso visione&nbsp;
                                                <a
                                                  href={URL.informativaprivacyArAp}
                                                  target="_blank"
                                                  rel="noreferer, ,noopener"
                                                >
                                                    dell'informativa privacy
                                                </a>
                                            </div>) :
                                          (
                                            <div
                                                className="login-dropdown_title col-xs-22 col-xs-offset-1 col-md-22 col-md-offset-1 col-lg-20 col-lg-offset-2">
                                                  Password scaduta, inserisci una nuova password
                                            </div>
                                          )
                                        }
                                    </>
                                }
                            </div>
                            {changePassword ? (
                              <ChangePasswordForm
                                username={changePasswordUsername}
                                oldPassword={changePasswordPassword}
                                onLoadStart={() => setLoadingStatus(true)}
                                onLoadEnd={() => setLoadingStatus(false)}
                              />
                            ) : (
                              <LoginForm
                                isCaptchaDisabled={isCaptchaDisabled}
                                authFailed={authFailed}
                                onSubmit={login}
                                    onLoadStart={() => setLoadingStatus(true)}
                                    onLoadEnd={() => setLoadingStatus(false)}
                                />
                            )}
                        </div>
                    </LoginDropdown>
                )}
                {/* NOT LOGGED - END */}

                {/* LOGGEDIN - START */}
                {/* NOTIFICHE  */}
                {isLogged && isPF && !isLogoutOnly && (
                    <NotificheUtente
                        unreadNotifications={unreadNotifications}
                    />
                )}

                {/* INFO UTENTE */}
                {isLogged && (
                    <InfoUtente
                        isLogoutOnly={isLogoutOnly}
                        helloName={helloName}
                        privacyLevel={privacyLevel}
                    />
                )}
                {/* LOGGEDIN - END */}


                {/* #### Loader */}
                {isLoading && (
                    <LoginLoadingContainer>
                        <TpdLoading isLoading={true} overlayedSpinner={true} />
                    </LoginLoadingContainer>
                )}

                {/* #### Modal Error Login Service */}
                {isModalOpen && (
                    <TpdModal
                        buttonCloseOn={false}
                        title={(
                            <div>Attenzione</div>
                        )}
                        content={(
                            <div className="form-group">
                                <div className="row">
                                    <div className="subtitle">
                                        Si è verificato un errore. Si prega di riprovare più tardi.
                                    </div>
                                </div>
                            </div>
                        )}
                        footer={(
                            <button
                                className="tpd-button"
                                style={{ width: "200px", padding: 0, backgroundColor: "#c4151c" }}
                                onClick={handleLogoutFromErrorModal}
                            >
                                Chiudi
                            </button>
                        )}
                    />
                )}
            </LoginContainer>
        ) : null}
        </>
    )
};

export default Login;
